<template>

  <div>

    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <v-dialog v-model="show" max-width="500px">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card v-if="!!paymentInfo && plan">
        <v-card-title>
          <h2>Change Plan To {{ plan.name }}?</h2>
          <v-spacer></v-spacer>
          <v-btn flat icon color="itoviGrayMid" @click="show=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0 text-xs-left">

          <div class="mb-2">{{ plan.description }}</div>

          <v-layout align-center row wrap>
            <span class="txt-bold">Price:&nbsp;</span>
            <span class="txt-bold">${{ formatPrice(plan.price) }}</span>
          </v-layout>
          <v-layout align-center row wrap>
            <span class="txt-bold">Monthly:&nbsp;</span>
            <span class="txt-bold">${{ formatPrice(plan.monthly) }}</span>
            <span class="txt-bold"
                  style="font-size: 7pt;">&nbsp;/ mo</span>
          </v-layout>




          <!--      what's included section          -->
          <div v-if="!!plan.included && plan.included.length > 0" class="mt-2">
            <ul>
              <template v-for="(updradeDetailsIncludedItem, index2) in plan.included">
                <li :key="index2">{{ updradeDetailsIncludedItem }}</li>
              </template>
            </ul>
          </div>

          <div class="txt-bold mt-2" >Your card ending in {{ paymentInfo.last_four }} will be charged {{  plan.price > 0  ? `$${formatPrice(plan.price)} today` : '' }}  {{ plan.price > 0 && plan.monthly > 0 ? 'and ' : '' }} {{ plan.monthly > 0 ? `$${formatPrice(plan.monthly)} monthly, starting next month` : '' }}</div>

          <v-layout justify-center wrap class="mt-2">
            <v-btn round color="primary" @click="submitPlanChange">Confirm</v-btn>
          </v-layout>



        </v-card-text>

      </v-card>
    </v-dialog>
  </div>

</template>

<style lang="scss" scoped>
  .plan-title {
    font-size: 15pt;
    color: #027689;
  }
</style>

<script>
  import api from "../../../services/api_endpoints"
  import store from "../../../store"
  import LoadingDialog from "../../LoadingDialog"

  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      showLoadingDialog: false,
      snackbar: {
        success: false,
        error: false,
        timeout: 1500,
        errorMessage: "An unknown error occurred",
        successMessage: "Plan changed successfully"
      },
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      paymentInfo: {
        type: Object,
        default: ()=> ({})
      },
      onClose: {
        type: Function,
        default: ()=> ({})
      },
      plan: {
        type: Object,
        default: () => ({
          product_code: '',
          name: '',
          price: 0,
          monthly: 0,
          details: {
            included: [],
            description: null,
          }
        })
      },
    },
    methods: {
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async submitPlanChange() {
        // the the payment info so we can tell the user what card they are paying with
        this.payment_info = store.state.ccInfo

        this.showLoadingDialog = true
        let response = await api.submitPlanChange(this.plan.product_code)
        this.showLoadingDialog = false

        if (response.success) {
          this.snackbar.success = true
          this.show = false
        } else {
          if (response.errorMessage !== '') this.snackbar.errorMessage = response.errorMessage
          this.snackbar.error = true
        }
        if (this.isFunction(this.onClose)) this.onClose(response.success)
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
